import type { BestOfAwardsOffer } from '@cc-shopping/contracts/cross-site/marketplace/types';
import { ReviewBanner } from './components/ReviewBanner';
import { RoundupBanner } from './components/RoundupBanner';
import { BEST_OF_AWARDS_WINNERS_MAP } from './utils';

type Props =
  | {
      offerId: string;
      variant: 'review';
      isFeatureEnabled: boolean;
    }
  | {
      variant: 'roundup';
      roundupVariant: 'summary-table' | 'product-card';
      bestOfAwardsOffer: BestOfAwardsOffer;
    };

export function BestOfAwardsBanner(props: Props) {
  if (props.variant === 'roundup') {
    const { bestOfAwardsOffer, roundupVariant } = props;
    if (
      bestOfAwardsOffer?.showBestOfAwardsBadge &&
      bestOfAwardsOffer?.bestOfAwardsText &&
      bestOfAwardsOffer?.bestOfAwardsYear
    ) {
      return (
        <RoundupBanner
          award={bestOfAwardsOffer.bestOfAwardsText}
          variant={roundupVariant}
          year={bestOfAwardsOffer.bestOfAwardsYear}
        />
      );
    }
    return null;
  }

  const { offerId, isFeatureEnabled } = props;

  if (props.variant === 'review') {
    const awards = BEST_OF_AWARDS_WINNERS_MAP[offerId];
    if (!isFeatureEnabled || !awards) {
      return null;
    }
    return <ReviewBanner awards={awards} />;
  }
}
